var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2BF1E934-A255-44BE-8A2B-5C81149270F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.0193854%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBBD18",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B75400",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.5%",
    y1: "0%",
    x2: "62.5%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DA59",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC9902",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.7777778%",
    y1: "0%",
    x2: "72.2222222%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7E78F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EED12B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-PROPOSAL-00",
    transform: "translate(-914.000000, -110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(914.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.11,22 C12.558,22 12.11,21.552 12.11,21 L12.11,1 C12.11,0.448 12.558,0 13.11,0 L19.11,0 C19.662,0 20.11,0.448 20.11,1 L20.11,21 C20.11,21.552 19.662,22 19.11,22 L13.11,22 Z",
    id: "Fill-1",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.055,22.035 L7.055,22.035 C6.503,22.035 6.055,21.587 6.055,21.035 L6.055,7.035 C6.055,6.483 6.503,6.035 7.055,6.035 L13.055,6.035 C13.607,6.035 14.055,6.483 14.055,7.035 L14.055,21.035 C14.055,21.587 13.607,22.035 13.055,22.035",
    id: "Fill-3",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,22.035 L1,22.035 C0.448,22.035 0,21.587 0,21.035 L0,11.035 C0,10.483 0.448,10.035 1,10.035 L7,10.035 C7.552,10.035 8,10.483 8,11.035 L8,21.035 C8,21.587 7.552,22.035 7,22.035",
    id: "Fill-5",
    fill: "url(#linearGradient-3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReport);
export default __webpack_public_path__ + "static/media/ic_report.1c5f9c3ed26e995d44bf8fbe0672d0ba.svg";
export { ForwardRef as ReactComponent };